import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {PostRequestRegisterDocument} from 'domain/usecases/others/facial-biometric';
import {RemoteFacialBiometricPostRegisterDocument} from 'data/usecases/others/facial-biometric/request';
import {FacialBiometricEndpoints} from 'main/factories/usecases/endpoints';

export const makePostRequestFacialBiometricRegisterDocument = (): PostRequestRegisterDocument =>
	new RemoteFacialBiometricPostRegisterDocument(
		makeBFFApiUrl(FacialBiometricEndpoints.registerDocument),
		makeAuthorizeHttpClientDecorator(),
	);
